<template>
  <div class="number">
    <div id="okdata" class="oknumber">
      <div id="oknumber_c">
        <div class="container">

          <div class="container_personal">
            <!--会员分类排序头部-->
            <h2>{{ $t('okmain.c_member_contribute') }}</h2>
            <div class="zhibiao" style="margin-top: 0;">
              <span class="okrange">{{ $t('okmain.c_time') }}</span>
              <el-radio-group v-model="queryParams.time" @change="handleTimeChange" id="member_ct">
                <el-radio-button label="month">{{ $t('okmain.c_time1') }}</el-radio-button>
                <el-radio-button label="half">{{ $t('okmain.c_time2') }}</el-radio-button>
                <el-radio-button label="year">{{ $t('okmain.c_time3') }}</el-radio-button>
                <el-radio-button label="all">{{ $t('okmain.c_all') }}</el-radio-button>
              </el-radio-group>
            </div>
            <div class="zhibiao">
              <span class="okrange">{{ $t('okmain.c_metrics') }}</span>
              <el-radio-group v-model="queryParams.sort_by" size="medium" @change="handleSortByChange">
                <el-radio-button label="pr">{{ $t('okmain.pr') }}</el-radio-button>
                <el-radio-button label="issue">{{ $t('okmain.issues') }}</el-radio-button>
                <el-radio-button label="commit">{{ $t('okmain.commits') }}</el-radio-button>
                <el-radio-button label="code_line">{{ $t('okmain.code_lines') }}</el-radio-button>
              </el-radio-group>
            </div>
            <div class="zhibiao">
              <span class="okrange">{{ $t('okmain.c_range') }}</span>
              <el-radio-group v-model="queryParams.size" size="small" @change="handleSizeChange">
                <el-radio-button label="3">TOP 3</el-radio-button>
                <el-radio-button label="5">TOP 5</el-radio-button>
                <!-- <el-radio-button label="50">{{ $t('okmain.c_all') }}</el-radio-button> -->
              </el-radio-group>
            </div>
            <!--社区会员贡献-->
            <el-table :data="tablememberData" style="width: 100%" v-loading="loading" element-loading-text="数据加载中"
              element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.5)">
              <el-table-column type="index" :label="$t('okmain.c_sort')" min-width="5%"> </el-table-column>
              <!--  社区会员单位名称 -->
              <el-table-column prop="corporation" :label="$t('okmain.c_membername')" min-width="20%"> </el-table-column>
              <!-- 合并请求显示 -->
              <el-table-column prop="value" v-if="queryParams.sort_by == 'pr'" :label="$t('okmain.pr')" min-width="55%">
                <template slot-scope="tablememberData">
                  <el-progress :text-inside="true" typeof="line" :stroke-width="24"
                    :percentage="setpernalItemProgress(tablememberData.row.pr)"
                    :format="setperItemText(tablememberData.row.pr)"></el-progress>
                </template>
              </el-table-column>
              <!-- 问题显示 -->
              <el-table-column prop="issue" v-if="queryParams.sort_by == 'issue'" :label="$t('okmain.issues')"
                min-width="55%">
                <template slot-scope="tablememberData">
                  <el-progress :text-inside="true" typeof="line" :stroke-width="24"
                    :percentage="setpernalItemProgress(tablememberData.row.issue)"
                    :format="setperItemText(tablememberData.row.issue)"></el-progress>
                </template>
              </el-table-column>
              <!-- 代码行数 -->
              <el-table-column prop="code_line" v-if="queryParams.sort_by == 'code_line'" :label="$t('okmain.code_lines')"
                min-width="55%">
                <template slot-scope="tablememberData">
                  <el-progress :text-inside="true" typeof="line" :stroke-width="24"
                    :percentage="setpernalItemProgress(tablememberData.row.code_line)"
                    :format="setperItemText(tablememberData.row.code_line)"></el-progress>
                </template>
              </el-table-column>
              <!-- 提交数 -->
              <el-table-column prop="commit" v-if="queryParams.sort_by == 'commit'" :label="$t('okmain.commits')"
                min-width="55%">
                <template slot-scope="tablememberData">
                  <el-progress :text-inside="true" typeof="line" :stroke-width="24"
                    :percentage="setpernalItemProgress(tablememberData.row.commit)"
                    :format="setperItemText(tablememberData.row.commit)"></el-progress>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Number',
  data() {
    return {
      tablememberData: [],
      max_pr: 0,
      max_issue: 0,
      queryParams: {
        // since: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0],
        until: new Date().toISOString().split('T')[0],
        time: 'all', // 默认时间范围全部
        sort_by: 'pr',
        order: 'desc',
        size: 5, // 默认显示前3条数据
        page: 1,
      },
      loading: false,
    }
  },
  created() {
    this.getMemberData()
  },
  methods: {
    handleSortByChange(value) {
      this.queryParams.sort_by = value
      this.getMemberData()
    },
    handleSizeChange(value) {
      this.queryParams.size = value
      this.getMemberData()
    },
    handleTimeChange(value) {
      if (value == 'month') {
        // 计算出出最近一个月的时间，并赋值到查询参数中，如 2025-08-12
        this.queryParams.since = new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0];
        this.queryParams.until = new Date().toISOString().split('T')[0];
      } else if (value == 'half') {
        // 计算出最近半年的时间
        this.queryParams.since = new Date(new Date().setMonth(new Date().getMonth() - 6)).toISOString().split('T')[0];
        this.queryParams.until = new Date().toISOString().split('T')[0];
      } else if (value == 'year') {
        // 计算出最近一年的时间
        this.queryParams.since = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0];
        this.queryParams.until = new Date().toISOString().split('T')[0];
      } else if (value == 'all') {
        // 全部时间
        this.queryParams.since = null;
        this.queryParams.until = new Date().toISOString().split('T')[0];;
      }
      this.getMemberData();
    },
    setperItemText(row) {
      return () => {
        return row || '0';
      }
    },
    setpernalItemProgress(data) {
      let max = this.max_pr
      if (this.queryParams.sort_by == 'issue') {
        max = this.max_issue
      }
      if (this.queryParams.sort_by == 'code_line') {
        max = parseInt(this.tablememberData[0].code_line)
      }

      if (this.queryParams.sort_by == 'commit') {
        max = this.tablememberData[0].commit
      }

      if (data >= max) {
        return 90
      } else {
        return parseInt((data / max).toFixed(1) * 90) || 1
      }
    },
    // 个人的所有数据
    getMemberData() {
      this.loading = true;
      this.axios({
        method: 'get',
        // url: "http://localhost:10084/dashboard/cla/member",
        url: "https://id.openkylin.top/prod-api/dashboard/cla/member",
        params: this.queryParams
      }).then(repos => {
        this.tablememberData = repos.data.data;
        this.max_pr = this.tablememberData[0].pr
        this.max_issue = this.tablememberData[0].issue
        this.loading = false
      }).catch(function (error) {
        console.log(error);
        this.loading = false
      })
    },
  }

}




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Member.vue